/**
 * @generated SignedSource<<f648e223b40724c234d7706ccbc51ce9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShoppingButton_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAddItemToCart_user">;
  readonly " $fragmentType": "PdpSharedShoppingButton_user";
};
export type PdpSharedShoppingButton_user$key = {
  readonly " $data"?: PdpSharedShoppingButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShoppingButton_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAddItemToCart_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ca0d09a6adad5cd874cfa72c3f5450c3";

export default node;
